export class SimpleCardsCarousel {
  constructor(selectors) {
    this.SELECTORS = selectors;
    this.swiperInstance = null;
    this.prevButton = null;
    this.nextButton = null;
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      const swiperWrapper = document.querySelector(this.SELECTORS.swiperWrapper);
      swiperWrapper.style.gap = '0';
      this.initSwiper();
    });
  }

  initSwiper() {
    const refContainer = document.querySelector(this.SELECTORS.refContainer);
    const swiperWrapper = document.querySelector(this.SELECTORS.swiperWrapper);
    this.prevButton = document.querySelector(this.SELECTORS.prevButton);
    this.nextButton = document.querySelector(this.SELECTORS.nextButton);

    if (!refContainer || !swiperWrapper || !this.prevButton || !this.nextButton) {
      console.error('Required elements not found');
      return null;
    }

    const refRect = refContainer.getBoundingClientRect();
    const offsetBefore = refRect.left;

    // Initialize Swiper
    const swiper = new Swiper(this.SELECTORS.swiper, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: false,
      slidesOffsetBefore: offsetBefore,
      slidesOffsetAfter: 16,
      navigation: {
        nextEl: this.SELECTORS.nextButton,
        prevEl: this.SELECTORS.prevButton,
      },
      watchOverflow: true,
    });

    this.swiperInstance = swiper;

    // Set initial state of buttons
    this.updateButtonsState();

    // Add event listeners to update button states when slides change
    swiper.on('slideChange', this.updateButtonsState.bind(this));

    // Add resize event listener separately
    window.addEventListener('resize', () => {
      const newOffsetBefore = refContainer.getBoundingClientRect().left;
      if (swiper && swiper.params) {
        swiper.params.slidesOffsetBefore = newOffsetBefore;
        swiper.update();
      }
    });

    return swiper;
  }

  updateButtonsState() {
    if (!this.prevButton || !this.nextButton) return;

    this.prevButton.style.opacity = this.swiperInstance.isBeginning ? '0.5' : '1';
    this.prevButton.style.pointerEvents = this.swiperInstance.isBeginning ? 'none' : 'auto';

    // Get Swiper's max translate position
    const maxTranslate = this.swiperInstance.maxTranslate();
    const currentTranslate = this.swiperInstance.translate;

    if (currentTranslate <= maxTranslate + 5) {
      this.nextButton.style.opacity = '0.5';
      this.nextButton.style.pointerEvents = 'none';
    } else {
      this.nextButton.style.opacity = '1';
      this.nextButton.style.pointerEvents = 'auto';
    }
  }
}